import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import {
  IonAvatar,
  IonButton,
  IonLabel,
  IonMenuToggle,
} from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserProfile } from 'src/app/core/models/user-profile.model';
import { AppState } from 'src/app/core/store/app.state';
import { logout } from 'src/app/core/store/user/user.actions';
import { selectUserProfile } from 'src/app/core/store/user/user.selectors';

interface ViewModel {
  user: UserProfile | null;
}

@Component({
  selector: 'app-menu-profile',
  templateUrl: './menu-profile.component.html',
  styleUrls: ['./menu-profile.component.scss'],
  imports: [AsyncPipe, IonAvatar, IonLabel, IonButton, IonMenuToggle],
})
export class MenuProfileComponent {
  vm$: Observable<ViewModel>;

  constructor(private store: Store<AppState>) {
    this.vm$ = this.store
      .select(selectUserProfile)
      .pipe(map((user) => ({ user })));
  }

  logout() {
    this.store.dispatch(logout());
  }
}
